import { render, staticRenderFns } from "./EmailAuthentication.vue?vue&type=template&id=ec62cd3a&scoped=true"
import script from "./EmailAuthentication.vue?vue&type=script&lang=ts"
export * from "./EmailAuthentication.vue?vue&type=script&lang=ts"
import style0 from "./EmailAuthentication.vue?vue&type=style&index=0&id=ec62cd3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec62cd3a",
  null
  
)

export default component.exports